export const ADD_ELEM = "ADD_ELEM";
export const TOGGLE_ELEM = "TOGGLE_ELEM";
export const HOST = "localhost";

//User
export const SETUSER = "SETUSER";
export const SETUSEROUT = "SETUSEROUT";
export const SETARTWORKS = "SETARTWORKS";

//export const SERVER = "https://banjdevapi.herokuapp.com";
//export const SERVER_CHAT = "https://chatdevht.herokuapp.com/";
//export const SERVER = "http://localhost:1337";
export const SERVER = "https://vilajadmin.herokuapp.com";
